<div>
    <bko-kartlegging-header/>

    @switch (currentPage()) {
        @case (KartleggingSide.Kategori) {
            <bko-category-intro
                [title]="categoryTitle()"
                [description]="categoryDescription()"
                [imageUri]="categoryImageUri()"
                [imageType]="categoryImageType()"
                [showPreviousButton]="showPreviousButton()"
                (previous)="onPrevious()"
                (next)="onBeginCategory()"
            />
        }
        @case (KartleggingSide.Sporsmal) {
            <bko-question
                [questionText]="questionText()"
                [imageUri]="questionImageUri()"
                [imageType]="questionImageType()"
                [helpText]="helpText()"
                [questionType]="questionType()"
                [nextButtonText]="nextButtonText()"
                [currentCategoryNumber]="currentCategoryNumber()"
                [totalNumberOfCategories]="totalNumberOfCategories()"
                [categoryTitle]="categoryTitle()"
                [categoryIconUri]="categoryIconUri()"
                [categoryIconType]="categoryIconType()"
                [totalNumberOfQuestionsInCategory]="totalNumberOfQuestionsInCategory()"
                [currentQuestionNumber]="currentQuestionNumber()"
                [alternatives]="currentAlternatives()"
                [form]="currentForm()"
                (previous)="onPrevious()"
                (next)="onNext()"
            />
        }
    }
</div>
